import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/login/LoginPage';
import DashboardPageWrapper from './pages/dashboard/DashboardPageWrapper';
import FamiliesMobile from './pages/families/FamiliesMobile';
import ExpensesCategoriesPageWrapper from './pages/expenses/categories/ExpensesCategoriesPageWrraper';
import { ExpenseReportPage } from './pages/expenses/ExpenseReportPage';
import ExpensesPageWrapper from './pages/expenses/expenses/ExpensesPageWrraper';
import GiftsDashboardPageWrapper from './pages/gifts/dashboard/GiftsDashboardPageWrapper';
import EventsPageWrapper from './pages/gifts/events/EventsPageWrraper';
import GiftGiversPageWrapper from './pages/gifts/givers/GiftGiversPageWrapper';
import GiftsPageWrapper from './pages/gifts/gifts/GiftsPageWrapper';
import IncomePageWrapper from './pages/income/income/IncomePageWrapper';
import WalletPageWrapper from './pages/income/wallet/WalletPageWrapper';
import TransactionsPageWrapper from './pages/transactions/TransactionsPageWrapper';
import YouTubePlayerPage from './pages/youtube/YouTubePlayerPage';
import AppLayout from './components/common/AppLayout';
import './App.css';


const { Content } = Layout;

const App = React.memo(() => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AppLayout>
      <Content style={{ padding: '0', height: '100%', overflow: 'auto', width: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/families" element={<FamiliesMobile />} />
          <Route path="/expenses" element={<ExpensesPageWrapper />} />
          <Route path="/expenses/categories" element={<ExpensesCategoriesPageWrapper />} />
          <Route path="/expenses/reports" element={<ExpenseReportPage />} />
          <Route path="/income" element={<IncomePageWrapper />} />
          <Route path="/gifts" element={<GiftsDashboardPageWrapper />} />
          <Route path="/gifts/list" element={<GiftsPageWrapper />} />
          <Route path="/gifts/events" element={<EventsPageWrapper />} />
          <Route path="/gifts/givers" element={<GiftGiversPageWrapper />} />
          <Route path="/dashboard" element={<DashboardPageWrapper />} />
          <Route path="/income/wallet" element={<WalletPageWrapper />} />
          <Route path="/transactions" element={<TransactionsPageWrapper />} />
          <Route path="/youtube" element={<YouTubePlayerPage />} />
        </Routes>
      </Content>
    </AppLayout>
  );
});

App.displayName = 'App';

export default App; 